import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-20 bg-white" data-id="element-92">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-93">
        <FadeIn data-id="element-94">
          <div className="mb-12 relative" data-id="element-95">
            <span className="absolute -top-10 -left-6 text-8xl text-cream-dark font-serif leading-none" data-id="element-96">
              "
            </span>
            <p className="text-2xl md:text-3xl font-serif italic text-brown leading-relaxed relative z-10" data-id="element-97">
              Son las 6:30 PM. Tu hijo, que ayer era un ángel, hoy grita por un
              bloque mal puesto, rechaza la cena que antes amaba y parece no
              escucharte. Sientes ese nudo en el estómago, el calor subiendo por
              tu cuello y una pregunta que te persigue:{' '}
              <span className="text-terracotta font-medium" data-id="element-98">
                "¿Qué estoy haciendo mal?"
              </span>
              .
            </p>
            <span className="absolute -bottom-16 -right-6 text-8xl text-cream-dark font-serif leading-none" data-id="element-99">
              "
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-100">
          <div className="w-16 h-px bg-terracotta/30 mx-auto mb-10" data-id="element-101"></div>
          <p className="text-lg text-brown-light leading-relaxed" data-id="element-102">
            No has hecho nada mal. Tu hijo no se ha "roto" ni es rebelde. Está
            atravesando un salto de desarrollo que su cerebro no sabe procesar,
            y tú necesitas el mapa para guiarlo sin perder tu salud mental en el
            proceso.
          </p>
        </FadeIn>
      </div>
    </section>;
}